import React, { useEffect, useState, useRef, useMemo } from "react";
import AgentLayout from "../components/AgentLayout";
import NavButton from "../components/NavButton";
import DatePickerComponent from "../../client/components/DatePickerComponent";
import axiosInstance from "../../../utils/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import EasyGrid from "../../client/components/EasyGrid";
import Bootstrap4DatePickerComponent from "../../client/components/Bootstrap4DatePickerComponent";
import { isMobile } from "react-device-detect";

import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

export const LABEL_BY_KEY = {
  cricket_amount: "Cricket",
  cricket_bookmaker: "Cricket Bookmaker",
  cricket_fancy_amount: "Cricket Fancy",
  cricket_bf_fancy_amount: "Cricket BF Fancy",
  cricket_evenodd: "Cricket Even/Odd",
  cricket_figure: "Cricket Figure",
  cricket_toss: "Cricket Toss",
  cricket_tie: "Cricket Tie",
  football_amount: "Football",
  football_set_amount: "Football Set",
  tennis_amount: "Tennis",
  horserace_amount: "Horse Race",
  grayhound_amount: "Greyhound",
  betfairgames_amount: "Betfair Games",
  teenpati_studio_amount: "Teenpati Studio",
  galaxy_casino_amount: "Galaxy Casino",
  world_casino_amount: "World Casino"
};
const BookDetails2 = () => {
  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);
  const [showLoader, setShowLoader] = useState(false);
  const [plData, setPlData] = useState(null);
  const [plus, setPlus] = useState([]);
  const [minus, setMinus] = useState([]);
  const userInfo = useSelector((state) => state.userStore);
  const [filteredPlData, setFilteredPlData] = useState(null);
  const [detailsShow, setDetailsShow] = useState(false);
  const [eventTitle, setEventTitle] = useState("");
  const [plusTotal, setPlusTotal] = useState("");
  const [minusTotal, setMinusTotal] = useState("");
  const [plDataDetails, setPlDataDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState(10);
  const [eventDetailsDisplay, setEventDetailsDisplay] = useState(false);
  const [detailsUsername, setDetailsUsername] = useState("");

  const gridTableRef = useRef(null);
  const gridTableRef2 = useRef(null);
  const defaultExpand = true;
  const [gridKey, setGridKey] = useState(Date.now());
  const [gridKey2, setGridKey2] = useState(Date.now());
  const [gridKey3, setGridKey3] = useState(Date.now());
  const [gameType, setGameType] = useState("");
  const [marketType, setMarketType] = useState("");

  function escapeHtml(str = "") {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const cols = useMemo(
    () => [
      {
        title: "Event",
        data: "market_name",
        responsivePriority: 1,
        render: function (d, type, row) {
          //debugger;
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          //const key = escapeHtml(String(row.game_type ?? ""));

          return `<a href="#" class="dt-user-link" data-row-key="${key}" 
          style="color:#00b181;cursor:pointer;padding-left:4px;font-size: 1rem;">${safe}</a>`;
        }
      },
      {
        title: "Amount",
        data: "amount",
        render: (d) =>
          d < 0
            ? `<span style="color:#f00;font-size: 1rem;" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`
            : `<span style="color:#0b6222;font-size: 1rem;" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`,
        responsivePriority: 2
      },
      {
        title: "",
        data: "_id",
        visible: false,
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 3
      },
      {
        title: "game_type",
        data: "game_type",
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 7,
        visible: false
      },
      {
        title: "market_type",
        data: "market_type",
        render: (d) => `<span>${d}</span>`,
        visible: false,
        responsivePriority: 8
      }
    ],
    []
  );

  const cols2 = useMemo(
    () => [
      {
        title: "Name",
        data: "uname",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#" class="dt-user-link" data-row-key="${key}" class="site_family" 
          style="color:#00b181;cursor:pointer;padding-left:4px;font-size: 1rem;">${safe}</a>`;
        }
      },
      {
        title: "Amount",
        data: "winAmount",
        render: (d) =>
          d < 0
            ? `<span style="color:#f00;font-size: 1rem;" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`
            : `<span style="color:#0b6222;font-size: 1rem;" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`,
        responsivePriority: 2
      },
      {
        title: "",
        data: "id",
        visible: false,
        render: (d) =>
          `<span class="site_family" style="font-size: 1rem;">${d}</span>`,
        responsivePriority: 3
      }
    ],
    []
  );

  const colsDetails = useMemo(
    () => [
      {
        title: "Date",
        data: "stmp",
        order: "asc",
        width: isMobile ? "50px" : "200px",
        className: "dt-right",
        responsivePriority: 2,
        render: (d, type) => {
          if (type === "display" || type === "filter") {
            if (!d) return "";
            const dt = new Date(d);
            const datePart = dt.toLocaleDateString("en-US", {
              month: "2-digit",
              day: "2-digit",
              year: "numeric"
            });
            const fullTime = dt.toLocaleTimeString(undefined, {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            });
            // Split "04:47 pm" into time "04:47" and meridiem "pm"
            const meridiemMatch = fullTime.match(/^([\d:]+)\s*(am|pm)$/i);
            if (meridiemMatch) {
              const hhmm = meridiemMatch[1];
              const meridiem = meridiemMatch[2];
              if (isMobile) {
                return `<span class="date-cell-wrap"><span class="date-part" style="font-size:0.9;font-weight:400">${datePart}</span><span class="date-time-block"><br><span class="date-time" style="font-size:0.9;font-weight:400">${hhmm}</span><br> <span class="date-meridiem" style="font-size:0.9;font-weight:400">${meridiem}</span></span></span>`;
              } else {
                return `<span class="date-cell-wrap"><span class="date-part" style="font-size:0.9;font-weight:400">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:0.9;font-weight:400">${hhmm}</span><span class="date-meridiem" style="font-size:0.9;font-weight:400">${meridiem}</span></span></span>`;
              }
            }
            return `<span class="date-cell-wrap"><span class="date-part" style="font-size:0.9;font-weight:400">${datePart}</span><span class="date-time-block"><span class="date-time" style="font-size:0.9;font-weight:400">${fullTime}</span></span></span>`;
          }
          return d ? new Date(d).getTime() : 0;
          /*
          if (type === "display" || type === "filter") {
            return d ? new Date(d).toLocaleString() : "";
          } 
          return d ? new Date(d).getTime() : 0;*/
        }
      },
      {
        title: "Event",
        data: "match",
        render: function (d, type, row) {
          let safe = "";
          if (row.game_type == 1) {
            if (row.market_type == 1) {
              safe = escapeHtml(String(d ?? "")) + "/Match ODD";
            }
            if (row.market_type == 2) {
              safe = escapeHtml(String(d ?? "")) + "/Bookmaker";
            } else if (row.market_type == 5) {
              safe = escapeHtml(String(d ?? "")) + "/TIE";
            } else {
              safe = escapeHtml(String(d ?? ""));
            }
          } else {
            safe = escapeHtml(String(d ?? ""));
          }

          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#"  class="site_family" data-row-key="${key}"
           style="color:#000000;cursor:pointer;padding-left:4px;text-decoration:none;font-size:0.9rem;word-wrap:anywhere;" onClick="showBetDetails('${row.id}',${row.game_type},${row.market_type},${row.user_role})"
           >${safe}</a>`;
        },
        responsivePriority: 2
      },
      {
        title: "",
        data: "user_role",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 3
      },
      {
        title: "",
        data: "id",
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 7,
        visible: false
      },
      {
        title: "game_type",
        data: "game_type",
        render: (d) => `<span>${d}</span>`,
        responsivePriority: 7,
        visible: false
      },
      {
        title: "market_type",
        data: "market_type",
        render: (d) => `<span>${d}</span>`,
        visible: false,
        responsivePriority: 8
      },
      {
        title: "Amount",
        data: "win_amt",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          //return `<a href="#" class="dt-user-link" data-row-key="${key}" style="color:#00b181;cursor:pointer">${safe}</a>`;
          return safe < 0
            ? `<a href="#" class="dt-user-link site_family" data-row-key="${key}" style="color:#f00;cursor:pointer;font-size: 1rem;">${formatTruncate(
                safe
              )}</a>`
            : `<a href="#" class="dt-user-link site_family" data-row-key="${key}" style="color:#0b6222;cursor:pointer;font-size: 1rem;">${formatTruncate(
                safe
              )}</a>`;
        }
      }
    ],
    []
  );

  let username = "";
  let userId = "";

  const handleUserClick = async (user) => {
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);

    setShowLoader(true);
    setDetailsUsername(user.uname);

    const response = await axiosInstance.post(
      "master/book-detail/pl-by-type-bet-list",
      {
        userId: user.user_id,
        game_type: gameType,
        market_type: marketType,
        frm,
        til
      }
    );

    setPlDataDetails(
      response.data.betList.map((item, idx) => ({
        ...item,
        _id: item._id ?? item.tid ?? `${item.match}_${idx}_${Math.random()}`
      }))
    );

    setShowLoader(false);
    setIsLoading(false);
    setGridKey3(Date.now());
  };

  useEffect(() => {
    window.showBetDetails = (id, game_type, market_type, user_role) => {
      if (user_role == 8) {
        let popup = null;
        if (game_type == 7 || game_type == 10) {
          //betTPandGalaxyDetailsVirtualView(row.id);
          popup = window.open(
            "/client-tp-details-view/" + id,
            "",
            "width=700,height=500"
          );
        } else if (game_type == 6) {
          betDetailsCasinoView(id);
        } else {
          if (game_type == 9) {
            //betDetailsVirtualView(row.id);
            popup = window.open(
              "/client-virtual-details-view/" + id,
              "",
              "width=700,height=500"
            );
          } else {
            //betDetailsView(row.id);
            popup = window.open(
              "/clinet-bet-details-view/" + id,
              "",
              "width=700,height=500"
            );
          }

          if (popup) {
            popup.document.title = "BPEXCH";
          }
        }
      } else {
        openPopUp(id);
      }
    };

    return () => {
      delete window.showBetDetails;
    };
  }, []);

  const betDetailsCasinoView = async (id) => {
    const popup = window.open(
      "/client-casino-details-view/" + id,
      "",
      "width=700,height=500"
    );

    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const openPopUp = async (id) => {
    const popup = window.open(
      "/plby-hierarchical/" + id,
      "",
      "width=700,height=500"
    );
    if (popup) {
      popup.document.title = "BPEXCH";
    }
  };

  const handleClickDetails = async (row) => {
    openPopUp(row.id);
  };

  if (
    userInfo !== null &&
    userInfo !== undefined &&
    userInfo.data !== null &&
    userInfo.data !== undefined
  ) {
    userId = userInfo.data._id;
    username = userInfo.data.uname;
  }

  const startDateSet = (date) => {
    setStartDate(date);
  };

  const endDateSet = (date) => {
    setEndDate(date);
  };

  function toLocalString(d) {
    const pad = (x) => String(x).padStart(2, "0");
    return (
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
      `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    );
  }

  const getBookDetails = async () => {
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);
    setShowLoader(true);

    const response = await axiosInstance.post("master/book-detail/pl-by-type", {
      userId: userId,
      frm,
      til
    });

    setPlData(response.data);
    setIsLoading(false);
    setShowLoader(false);
    const exclude = ["user_id", "from", "to", "grandTotal"];
    setFilteredPlData(
      Object.fromEntries(
        Object.entries(response.data).filter(([key]) => !exclude.includes(key))
      )
    );
    setDetailsShow(true);
  };

  useEffect(() => {
    getBookDetails();
  }, []); // Empty dependency array

  const handleClick = async (val) => {
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);
    setShowLoader(true);

    const response = await axiosInstance.post("master/get-market-pl-book2", {
      frm,
      til,
      game_type: val.game_type,
      market_type: val.market_type,
      user_id: val.user_id
    });

    setGameType(val.game_type);
    setMarketType(val.market_type);

    setEventTitle(response.data.Title);
    setPlusTotal(response.data.plusTotal);
    setMinusTotal(response.data.minusTotal);

    setPlus(response.data.plus);
    setMinus(response.data.minus);
    setShowLoader(false);
    setIsLoading(false);
  };

  const grandTotalNum =
    plData != null &&
    plData.grandTotal !== undefined &&
    plData.grandTotal !== null &&
    plData.grandTotal !== ""
      ? Number(plData.grandTotal)
      : null;
  const grandTotalValid =
    grandTotalNum !== null && !Number.isNaN(grandTotalNum);
  const grandTotalProfit = grandTotalValid && grandTotalNum > 0;
  const grandTotalLoss = grandTotalValid && grandTotalNum < 0;

  return (
    <AgentLayout>
      <style>{`.react-datepicker-popper {
             left: unset;
        }
        @media (max-width: 640px) {
          #ReportFilterForm .row > .col-12.col-md-5 {
            flex: 0 0 100%;
            max-width: 100%;
            margin-bottom: 8px;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .react-datepicker-wrapper,
          #ReportFilterForm .row > .col-12.col-md-5 .react-datepicker__input-container,
          #ReportFilterForm .row > .col-12.col-md-5 .form-group,
          #ReportFilterForm .row > .col-12.col-md-5 .input-group {
            width: 100% !important;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .input-group .form-control {
            flex: 1;
          }
          #ReportFilterForm .row > .col-12.col-md-5 .input-group-addon {
            display: flex;
            align-items: center;
          }
          #ReportFilterForm .input-group {
            flex-wrap: nowrap !important;
          }
          #ReportFilterForm .input-group .input-group-addon {
            display: flex;
            align-items: stretch;
          }
          #ReportFilterForm .input-group .input-group-addon .input-group-text {
            display: flex;
            align-items: center;
            align-self: stretch;
            height: auto;
            padding: 0 0.75rem;
            background-color: #e9ecef;
            border: 1px solid #ced4da;
            border-left: none;
            border-radius: 0 0.25rem 0.25rem 0;
          }
          #ReportFilterForm .input-group .form-control {
            border-radius: 0.25rem 0 0 0.25rem;
          }
          #ReportFilterForm .row > strong {
            display: none;
          }
          #ReportFilterForm .row > .editsbmtbtn {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            padding-right: 20px;
          }
        }`}</style>
      <div className="container-fluid">
        <div
          className="loaderAgent"
          style={{ display: showLoader ? "" : "none" }}
        >
          <img src="/assets/images/loadinggif.gif" />
        </div>

        <div class="bets-section-wrapper">
          <div>
            <NavButton></NavButton>
          </div>

          <div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <i className="fa fa-filter"></i>
                    <strong className="site_family">Report Filter</strong>
                  </div>
                  <div
                    className="card-body"
                    style={{ padding: "0.8rem 1.25rem" }}
                  >
                    <form
                      id="ReportFilterForm"
                      className="form-inline"
                      method="get"
                    >
                      <div className="row" style={{ textAlignLast: "justify" }}>
                        <div className="col-12 col-md-5">
                          <Bootstrap4DatePickerComponent
                            pickerId="ReportFrom"
                            inputId="DisplayFrom"
                            defaultDate={startDate}
                            setSelectedDate={startDateSet}
                          />
                          {/*<DatePickerComponent
                            defaultDate={startDate}
                            setSelectedDate={startDateSet}
                        />*/}
                        </div>
                        <strong style={{ margin: "auto" }}>
                          &nbsp;-&nbsp;
                        </strong>
                        <div className="col-12 col-md-5">
                          <Bootstrap4DatePickerComponent
                            pickerId="ReportTo"
                            inputId="DisplayTo"
                            defaultDate={endDate}
                            setSelectedDate={endDateSet}
                          />

                          {/*<DatePickerComponent
                            defaultDate={endDate}
                      setSelectedDate={endDateSet}/>*/}
                        </div>
                        <div className="form-group editsbmtbtn">
                          <button
                            onClick={() => getBookDetails()}
                            className="btn btn-success"
                            style={{ background: "#02b181" }}
                            type="button"
                          >
                            <strong className="site_family">Submit</strong>
                          </button>
                        </div>
                      </div>
                      <div className="row col-12"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bets-wrapper" style={{ marginTop: "0px" }} id="top_div">
          <div class="row">
            <div class="col-md-6" style={{ marginTop: "0px" }}>
              <div>
                <div class="card">
                  <div class="card-header site_family">
                    <div style={{ float: "left" }}>
                      <i class="fa fa-align-justify"></i>
                      <span
                        style={{ fontWeight: "bold", paddingLeft: "10px" }}
                        className="site_family"
                      >
                        {username}
                      </span>
                    </div>
                  </div>
                  <div class="card-body" style={{ paddingTop: "0px" }}>
                    <div class="row" style={{ display: "unset" }}>
                      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="row">
                          <div class="col-sm-12"></div>
                        </div>
                        <div class="row">
                          <div
                            class="col-sm-12"
                            style={{ display: detailsShow ? "" : "none" }}
                          >
                            {plData && (
                              <>
                                <EasyGrid
                                  responsiveMode="hybrid"
                                  cols={cols}
                                  dataset={plData.data}
                                  isLoading={isLoading}
                                  pageSize={pageSize}
                                  handleUserClick={handleClick}
                                />
                                {grandTotalValid && (
                                  <table
                                    className={`table table-sm${
                                      grandTotalProfit ? " dataTable" : ""
                                    }`}
                                  >
                                    <tbody>
                                      <tr
                                        style={{
                                          background: grandTotalProfit
                                            ? "#00b483"
                                            : grandTotalLoss
                                            ? "#f86d6b"
                                            : "#00b483",
                                          color: "white"
                                        }}
                                      >
                                        <td
                                          className="site_family"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Total
                                        </td>
                                        <td
                                          className="site_family"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {formatTruncate(
                                            Math.round(grandTotalNum)
                                          )}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              {eventTitle && (
                <div style={{ marginTop: "0px", display: "" }}>
                  {plDataDetails && (
                    <div class="card">
                      <div class="card-header">
                        <div style={{ float: "left" }}>
                          <i class="fa fa-align-justify"></i>
                          <span
                            style={{ fontWeight: "bold" }}
                            className="pl-2 site_family"
                          >
                            {eventTitle}
                          </span>
                        </div>
                      </div>
                      <div class="card-body">
                        <div className="row no-gutters">
                          <div className="col-6 pr-1">
                            <EasyGrid
                              responsiveMode="hybrid"
                              cols={cols2}
                              dataset={plus}
                              isLoading={isLoading}
                              pageSize={pageSize}
                              handleUserClick={handleUserClick}
                              ordering={false}
                            ></EasyGrid>
                          </div>
                          <div className="col-6 pl-1">
                            <EasyGrid
                              responsiveMode="hybrid"
                              cols={cols2}
                              dataset={minus}
                              isLoading={isLoading}
                              pageSize={pageSize}
                              handleUserClick={handleUserClick}
                              ordering={false}
                            ></EasyGrid>
                          </div>

                          <div className="col-6 pr-1">
                            <table className="table table-sm dataTable">
                              <tbody>
                                <tr
                                  style={{
                                    color: "white",
                                    background: "#00b281"
                                  }}
                                >
                                  <td
                                    className="site_family"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    Total
                                  </td>
                                  <td
                                    className="site_family"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {formatTruncate(plusTotal)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-6 pl-1">
                            <table className="table table-sm">
                              <tbody>
                                <tr
                                  className="bg-danger"
                                  style={{ color: "white" }}
                                >
                                  <td
                                    className="site_family"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    Total
                                  </td>
                                  <td
                                    className="site_family"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {formatTruncate(minusTotal)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            {plDataDetails.length > 0 && (
              <div class="col-md-6">
                <div style={{ marginTop: "0px", display: "" }}>
                  <div class="card">
                    <div class="card-header">
                      <div style={{ float: "left" }}>
                        <i class="fa fa-align-justify"></i>
                        <span
                          style={{ fontWeight: "bold" }}
                          className="site_family"
                        >
                          {" "}
                          {detailsUsername} / {eventTitle}
                        </span>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-12">
                          {plDataDetails.length > 0 && (
                            <EasyGrid
                              responsiveMode="hybrid"
                              cols={colsDetails}
                              dataset={plDataDetails}
                              isLoading={isLoading}
                              pageSize={pageSize}
                              //handleUserClick={handleClickDetails}
                              ordering={false}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <style>{`

.loaderAgent {
   
  position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    opacity: .6;
    display: flex;
    justify-content: center;
    align-items: center; 
  background-image:
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0),
      linear-gradient(#000 20px, transparent 0);
  background-repeat: no-repeat;
  background-size: 20px auto;
  background-position: 0 0, 40px 0, 80px 0, 120px 0;
  animation: pgfill 1s linear infinite;
}

@keyframes pgfill {
  0% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  25% {
      background-image: linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  50% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  75% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0), linear-gradient(#000 20px, transparent 0);
  }

  100% {
      background-image: linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#000 20px, transparent 0), linear-gradient(#ddae29 20px, transparent 0);
  }
}

`}</style>
      </div>
    </AgentLayout>
  );
};

export default BookDetails2;
